<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="v3-magic-link">
  @if (!magicLinkSent) {
    <p class="v3-description fs-body-s">
      {{ 'translations.public.description.magicLinkInstructions' | transloco }}
    </p>
    <ptl-sg-button type="flat" color="primary" class="v3-submit" [disabled]="magicLinkRequestInProgress" (clicked)="requestLink.emit()">
      @if (!magicLinkRequestInProgress) {
        <span>{{ 'translations.public.button.sendSignInLink' | transloco }}</span>
      } @else {
        <span class="v3-submit-loading">
          <span>{{ 'translations.public.button.sendSignInLink' | transloco }}</span>
          <mat-spinner [diameter]="18"></mat-spinner>
        </span>
      }
    </ptl-sg-button>
  } @else {
    <div class="v3-magic-link-sent">
      <p class="v3-subtitle fs-body-m">
        {{ 'translations.public.description.magicLinkSent' | transloco: { email: email } }}
      </p>
      <ptl-sg-button
        type="stroked"
        color="primary"
        class="v3-submit"
        [disabled]="magicLinkRequestInProgress"
        (clicked)="requestLink.emit()"
      >
        @if (!magicLinkRequestInProgress) {
          <span>{{ 'translations.public.button.resendSignInLink' | transloco }}</span>
        } @else {
          <span class="v3-submit-loading">
            <span>{{ 'translations.public.button.resendSignInLink' | transloco }}</span>
            <mat-spinner [diameter]="18"></mat-spinner>
          </span>
        }
      </ptl-sg-button>
    </div>
  }

  <ptl-sg-button
    type="flat"
    color="primary"
    class="v3-submit v3-submit--soft"
    [text]="'translations.public.button.backToSignIn' | transloco"
    (clicked)="backToSignIn.emit()"
  ></ptl-sg-button>
</div>
